import RevisionList from './RevisionList';

export default RevisionList;
